module.exports = __webpack_public_path__ + "img/bed.bf8a33d9.svg";